import type React from 'react';

import { Avatar, Tags, Experience, Name } from '@features/coaches';

import * as st from './styles.module.scss';

interface Props {
	id: number;
	ModeSwitch?: JSX.Element;
	Calendar?: JSX.Element;
}

export const CoachModalCard: React.FC<Props> = ({ id, ModeSwitch, Calendar }) => {
	return (
		<div className={st.card}>
			<div className={st.card__avatar}>
				<Avatar id={id} />
			</div>
			<div className={st.card__info}>
				{/*<Name id={id} />*/}
				<Tags id={id} />
				<Experience id={id} />
				<div className={st.card__buttons}>{ModeSwitch}</div>
			</div>
			<div className={st.card__schedule}>{Calendar}</div>
		</div>
	);
};
